import React from "react";
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import _ from '../../../utils/ObjectUtils';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';

const TimeField =
    ({
         value = "",
         label = "",
         handleFieldChange,
         handleFieldBlur = () => { },
         error,
         disabled = false,
         width = 6
     }) => {
        return (
            <div className={"col-lg-" + width + ( width < 6 ? " col-md-6 " : " col-md-12 ")}>
                <FormControl
                    error={!_.isNilOrEmpty(error)}
                    disabled={disabled}
                >
                    <InputLabel
                        color="primary"
                        htmlFor="adornment-label"
                        shrink
                    >
                        {label}
                    </InputLabel>
                    <Input
                        id="adornment-label"
                        value={value}
                        type='time'
                        onChange={e => handleFieldChange(e.target.value)}
                        onBlur={handleFieldBlur}
                        aria-describedby="label-helper-text"
                        inputProps={{
                            "aria-label": "label",
                        }}
                        endAdornment={!disabled &&
                        <InputAdornment position="end">
                            <SvgIcon
                                viewBox="-8 -4 22 22"
                                className="text-field-clear-icon"
                                aria-label="Clear text field"
                                onClick={e => handleFieldChange("")}
                                cursor="initial"
                            >
                                <path d="M8.622 9.86c-.124.124-.259.102-.404-.044L4.99 6.589 1.771 9.805c-.146.146-.28.169-.405.045L.133 8.618c-.123-.123-.1-.256.045-.403L3.396 5 .178 1.785C.033 1.64.01 1.505.133 1.38L1.368.15c.123-.122.258-.1.403.046L4.989 3.41 8.22.183c.145-.145.28-.167.403-.045L9.856 1.37c.123.123.1.257-.045.403L6.58 5l3.23 3.227c.146.144.168.279.044.403L8.622 9.86z" />
                            </SvgIcon>
                        </InputAdornment>
                        }
                    />
                    <FormHelperText id="label-helper-text">{error}</FormHelperText>
                </FormControl>
            </div>
        );
    }

TimeField.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    handleFieldChange: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func,
    error: PropTypes.string,
    themeName: PropTypes.string
}

export default TimeField;